var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartOfAccounts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.333 26.154c0 .49-.179.959-.497 1.305a1.63 1.63 0 01-1.2.541H8.363a1.63 1.63 0 01-1.2-.54 1.932 1.932 0 01-.497-1.306V5.846c0-.49.18-.959.498-1.305A1.63 1.63 0 018.364 4h7.606a2 2 0 011.473.647l7.363 8.01a2 2 0 01.527 1.353v12.144zM11.903 11.385h3.49M11.903 16.923h8.727M11.903 22.462h8.727",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgChartOfAccounts;